var DB_Transaction = function(request, callback)
{
	var _transaction = this;
	_transaction.request = request;
	_transaction.callback = callback;
	_transaction.interface = {
		stack_item: $('<div></div>').StackItem(request)
	};

	_transaction.run = function()
	{
		if (_transaction.request != undefined){
			$.ajax({
				type: 'POST',
				url: "/api/post",
				data: _transaction.request,
				processData: false,
				contentType: false,
				success: _transaction.response,
				dataType: 'json'
			});
		}
	};

	_transaction.cancel = function()
	{
		_transaction.request = undefined;
		_transaction.interface.stack_item.delete();
	};

	_transaction.response = function(x)
	{
		if (x.success){
			_transaction.success(x);
		} else {
			_transaction.error(x);
		}
	};

	_transaction.success = function(x)
	{
		$.slr.react(_transaction, x);
		if (_transaction.callback != undefined){
			_transaction.callback(x);
		}
	};

	_transaction.error = function(x)
	{
		$.slr.react(_transaction, x);
	};

	return function()
	{
		$.slr.interface.stack.add(_transaction.interface.stack_item);
		return _transaction;
	}();
}

var DB = function()
{
	var _db = this;
	_db.queue = [];
	_db.status = {
		is_running: false,
		has_error: false
	}

	_db.next = function()
	{
		if (_db.queue.length > 0){
			var transaction = _db.queue.shift();
			transaction.run();
		} else {
			_db.ended();
		}
	};

	_db.add = function(request, callback)
	{
		if (_db.status.has_error){
			$.slr.warning(); return;
		}
		var transaction = new DB_Transaction(request, callback);
		_db.queue.push(transaction);
		$.slr.interface.stack.status.active = true;
		if (!_db.status.is_running){
			_db.next();
			_db.status.is_running = true;
		}
	};

	_db.empty_queue = function()
	{
		_db.queue.forEach(function(transaction, index){
			transaction.cancel();
		});
		_db.queue = [];
	};

	_db.ended = function()
	{
		_db.empty_queue();
		_db.status.is_running = false;
		$.slr.interface.stack.status.active = false;
	};

	return function(){
		return _db;
	}();
};
